export default {
  "pl": {
    "upsell": {
      "contact_us": "Skontaktuj się z nami",
      "decisions_partners": {
        "guidance": "Partnerzy decyzyjni mogą tworzyć i/lub zarządzać propozycjami, jeśli otrzymają pozwolenie <br>Więcej informacji o partnerach decyzyjnych <a class='is-underlined' href='/help/content/partners/ partners.html#decision-partners' target='_blank'>tutaj</a>",
        "intercom": "Witaj Ziggu! Interesuje mnie funkcja Partnerzy decyzyjny. Czy możesz podać więcej informacji? Z poważaniem, %{name}"
      },
      "decisions_reminders": {
        "guidance": "Przypomnienia umożliwiają automatyczne powiadamianie klientów o propozycjach oczekujących na decyzję.<br>Więcej informacji o przypomnieniach <a class='is-underlined' href='/help/content/decisions/decisions.html?#step-3-optional-settings' target='_blank'>tutaj</a>",
        "intercom": "Witaj Ziggu! Interesuje mnie funkcja Przypomnienia. Czy możesz podać więcej informacji? Z poważaniem, %{name}"
      },
      "milestones": {
        "cta_text": "Wygląda na to, że nie masz jeszcze tej funkcji",
        "guidance": "Ta funkcja pozwala w łatwy sposób informować klienta o postępie budowy",
        "intercom": "Witaj Ziggu! Interesuje mnie funkcja Kamienie milowe. Czy możesz podać więcej informacji? Z poważaniem, %{name}"
      },
      "not_included": "💡 Zainteresowany tą funkcją 💡",
      "proposal_choice_lists": {
        "guidance": "Listy wyboru umożliwiają klientom dokonywanie wyborów w ramach propozycji.<br>Więcej informacji o listach wyboru <a class='is-underlined' href='/help/content/decisions/decisions.html#choice-list' target='_blank'>tutaj</a>",
        "intercom": "Witaj Ziggu! Interesuje mnie funkcja Listy wyboru. Czy możesz podać więcej informacji? Z poważaniem, %{name}"
      },
      "signatures": {
        "cta_text": "Potrzebujesz podpisów do swoich dokumentów? Skontaktuj się z nami",
        "guidance": "Podpisy umożliwiają klientom cyfrowe podpisywanie ważnych dokumentów.<br>Więcej informacji o przypomnieniach <a class='is-underlined' href='/help/content/decisions/decisions.html#electronic-signature' target='_blank'>tutaj</a>",
        "intercom": "Witaj Ziggu! Interesuje mnie funkcja Podpisy. Czy możesz podać więcej informacji? Z poważaniem, %{name}"
      }
    }
  }
}
